import dynamic from 'next/dynamic';

import { Container } from 'components/Grid';

const InlineForm = dynamic(
  () => import('bx-forms/eas/getapp').then((mod) => mod.InlineForm),
  { ssr: false }
);
import LazyContent from 'components/LazyContent';

const GATEWAY_URL = 'https://www.capterra.com/bx-capterra-api/bx-forms/submit';

const InlineFaas = () => (
  <Container>
    <LazyContent minHeight={272}>
      <InlineForm
        formId="54K2nJFPvImG9HI5dhpiVd"
        gatewayUrl={GATEWAY_URL}
        formTemplate="INLINE_CARD"
        headline="Top-rated software of 2026"
        subHeading="Fill out the form and we'll send a list of the top-ranked software based on real user reviews directly to your inbox."
        buttonText="SEND ME THE LIST"
        successHeadline="Thank you, enjoy!"
        successMessage="Your list will be delivered to your inbox shortly."
        step2Subtitle="Thank you! Just one more question:"
        contextProps={{ pageType: 'home', pagePlacement: 'inline' }}
        tracking={{
          formName: 'DMBUY_2022_GA_Blog_Acq',
          contentCategory: 'Homepage_Inline',
          contentRequest: 'Top Software',
        }}
      />
    </LazyContent>
  </Container>
);

export default InlineFaas;
